export default class VideoAssembler {
  constructor () {
    this.frame = null
  }

  push (suffix, payload) {
    const parts = suffix.split('/')
    const frameId = parts[2]
    const index = Number(parts[3])
    const total = Number(parts[4])
    if (!frameId || !Number.isInteger(index) || !Number.isInteger(total) || total < 1 || index < 0 || index >= total) return null

    if (!this.frame || this.frame.id !== frameId) {
      this.frame = { id: frameId, total, chunks: new Array(total), received: 0 }
    }
    if (this.frame.total !== total || this.frame.chunks[index]) return null

    this.frame.chunks[index] = new Uint8Array(payload)
    this.frame.received += 1
    if (this.frame.received !== this.frame.total) return null

    const blob = new Blob(this.frame.chunks, { type: 'image/jpeg' })
    this.frame = null
    return blob
  }

  reset () {
    this.frame = null
  }
}
